// extracted by mini-css-extract-plugin
export default {"imageBlock":"users_imageBlock__46ZcL","userImage":"users_userImage__CYG-8"};